import { slideUp, slideDown } from './animations.js'; // Import slideUp and slideDown functions

// Create a state object to hold search-related properties
const searchState = {
    searchOpened: false,
    navSearchWrapper: null,
    searchInput: null,
    navHeadings: null,
    navLinks: null,
    subMenuWrapper: null
};

export function searchInit() {
    // Initialize state
    searchState.searchOpened = false;

    // Cache DOM elements
    searchState.navSearchWrapper = document.querySelector('.c-site-header__nav-search-wrapper');
    searchState.searchInput = document.querySelector('.c-search-bar__input');
    searchState.navHeadings = document.querySelectorAll('.c-nav-primary__heading');
    searchState.navLinks = document.querySelectorAll('.c-nav-primary__link');
    searchState.subMenuWrapper = document.querySelector('.c-nav-primary');

    // Set initial tabIndexes
    const searchBar = document.querySelector('.c-search-bar');
    if (searchBar) searchBar.setAttribute('tabIndex', '-1');
    if (searchState.searchInput) searchState.searchInput.setAttribute('tabIndex', '-1');
    searchState.navHeadings.forEach(heading => heading.setAttribute('tabIndex', '0'));

    // Bind event listeners
    const searchButton = document.querySelector('.c-site-header__search');
    const searchClose = document.querySelector('.c-search-bar__close');
    
    if (searchButton) {
        searchButton.addEventListener('click', openSearch);
    }
    if (searchClose) {
        searchClose.addEventListener('click', closeSearch);
    }
}

/**
 *
 * Open the search bar and hide the top nav
 *
 *
 */
export function openSearch() {
    if (!searchState.navSearchWrapper || !searchState.searchInput || !searchState.subMenuWrapper) return;

    searchState.navSearchWrapper.classList.add('c-site-header__nav-search-wrapper--search-active');
    searchState.searchInput.focus();
    searchState.searchInput.value = searchState.searchInput.value;

    // Apply tabIndex to the search box
    searchState.searchInput.setAttribute('tabIndex', '0');

    // Set tabIndex to -1 for the nav
    searchState.navHeadings.forEach(heading => heading.setAttribute('tabIndex', '-1'));
    searchState.navLinks.forEach(link => link.setAttribute('tabIndex', '-1'));

    // Hide the menu with a delay to match transition
    setTimeout(() => {
        if (searchState.subMenuWrapper) {
            searchState.subMenuWrapper.style.visibility = 'hidden';
        }
    }, 300);

    // Set var to show search has been opened
    searchState.searchOpened = true;
}

/**
 *
 * Close the search bar and show the top nav
 *
 *
 */
export function closeSearch() {
    if (!searchState.navSearchWrapper || !searchState.subMenuWrapper) return;

    searchState.navSearchWrapper.classList.remove('c-site-header__nav-search-wrapper--search-active');
    
    // Show the menu immediately
    searchState.subMenuWrapper.style.visibility = 'visible';
    
    // Set tabIndex to -1 for the search box
    if (searchState.searchInput) {
        searchState.searchInput.setAttribute('tabIndex', '-1');
    }

    // Apply tabIndexes to the nav
    searchState.navHeadings.forEach(heading => heading.setAttribute('tabIndex', '0'));
    searchState.navLinks.forEach(link => link.setAttribute('tabIndex', '0'));

    // Reset search state
    searchState.searchOpened = false;
}